<template>  
  <v-card light elevation="3" class="mb-4">
    <v-card-text class="pb-0">
      <div>{{ holiday.day | toLocalDate }}</div>
      <div class="text-h5">
        {{ holiday.description }}
      </div>
      <div v-if="isChristmasEve(holiday.day)">
        <v-alert
          icon="mdi-pine-tree"
          type="error"
          outlined
          prominent
          border="left"
        >
          <div class="text-h6">
            <b>Ange öppet/stängt på julafton.</b>
          </div>
          Tidningarna säljs 24–27/12 (i fyra dagar). Har ni öppet någon av dessa dagar ska ni ange <b>öppet</b> på julafton.
        </v-alert>       
      </div>
      <div v-if="holiday.message">
        <v-icon v-if="holiday.success === true" :color="holiday.success === true ? 'success' : 'error'">
          {{ holiday.success === true ? 'check_circle_outline' : 'error_outline' }}              
        </v-icon>
        {{ holiday.message }}
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn class="col-6" :color="holiday.open === true ? 'green white--text' : 'default'" 
             :loading="holiday.loading"
             :disabled="holiday.loading"
             @click="setOpen(holiday, true)"
      >
        Öppet
      </v-btn>
      <v-btn class="col-6 ml-1" :color="holiday.open === false ? 'red white--text' : 'default'" 
             :loading="holiday.loading"
             :disabled="holiday.loading"
             @click="setOpen(holiday, false)"
      >
        Stängt
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { clone } from 'lodash'
import api from '@/backend/api'
import log from '@/logger'


export default {
  name: 'Holiday',
  props: {
    holiday: {
      type: Object,
      required: true,
    }
  },
  methods: {
    isChristmasEve(day) {
      if (!day) {
        return false
      }
      const d = new Date(day)
      return d.getMonth() === 11 && d.getDate() === 24
    },
    setOpen(holiday, open) {
      holiday.loading = true
      delete holiday.message
      delete holiday.success
      var copy = clone(holiday)
      copy.open = open
      api.saveHoliday(copy)
        .then(resp => {
          holiday.message = resp.data.message
          holiday.success = resp.data.success
          holiday.loading = false
          log.debug('Resp:', resp.data)
          if (resp.data.success) {
            holiday.open = open
          }
          else{
            this.$toast.error(resp.data.message)
          }
        })
        .catch(error => {
          holiday.loading = false
          log.debug('Errors:', error)
        })
    }
  }
}
</script>
